import { render } from "./BackendContainer.vue?vue&type=template&id=2ea8db1d"
import script from "./BackendContainer.vue?vue&type=script&lang=ts"
export * from "./BackendContainer.vue?vue&type=script&lang=ts"

import "./BackendContainer.vue?vue&type=style&index=0&id=2ea8db1d&lang=scss"
script.render = render

export default script